export const RequireStar = () => (
  <span className="text-red text-xs mr-1">&#10033;</span>
);
